import Footer from "../components/Footer";
import Hero from "../components/Hero";
import Join from "../components/Join";
import MarketUpdate from "../components/MarketUpdate";
import WhyUs from "../components/WhyUs";

function Home() {
  return (
    <>
      <Hero />
      <MarketUpdate />
      <WhyUs />
      <Join />
      <Footer />
    </>
  );
}

export default Home;
